import app from 'flarum/forum/app';
import User from './User';
const translationPrefix = 'clarkwinkelmann-catch-the-fish.forum.table-ranking.';
export default class RoundRankings {
  rankings = null;
  oninit(vnode) {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/catchthefish-rounds/' + vnode.attrs.round.id() + '/rankings'
    }).then(result => {
      this.rankings = app.store.pushPayload(result);
      m.redraw();
    });
  }
  view(vnode) {
    if (this.rankings === null) {
      return m('p', app.translator.trans(translationPrefix + 'loading'));
    }
    return m('div', [m('h2', app.translator.trans(translationPrefix + 'title', {
      name: vnode.attrs.round.name()
    })), m('table.catchthefish-table', [m('thead', m('tr', [m('th', app.translator.trans(translationPrefix + 'rank')), m('th', app.translator.trans(translationPrefix + 'count')), m('th', app.translator.trans(translationPrefix + 'user'))])), m('tbody', this.rankings.map((ranking, index) => m('tr', [m('td', '#' + (index + 1)), m('td', ranking.catch_count()), m('td', m(User, {
      user: ranking.user()
    }))])))])]);
  }
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'forum/components/RoundRankings', RoundRankings);